var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIconNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#FFDEE0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.75 20.416L36.027 32.112C35.8423 35.1002 35.7499 36.5943 35.0009 37.6685C34.6306 38.1996 34.1538 38.6479 33.6008 38.9847C32.4825 39.666 30.9855 39.666 27.9915 39.666C24.9936 39.666 23.4947 39.666 22.3756 38.9834C21.8223 38.646 21.3453 38.197 20.9751 37.665C20.2264 36.589 20.136 35.0928 19.9554 32.1004L19.25 20.416",
    stroke: "#DF0C3D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 20.4163H38.5M32.7317 20.4163L31.9352 18.7734C31.4062 17.682 31.1416 17.1363 30.6853 16.7959C30.5841 16.7205 30.4769 16.6533 30.3649 16.5952C29.8596 16.333 29.2531 16.333 28.0403 16.333C26.797 16.333 26.1753 16.333 25.6616 16.6061C25.5478 16.6667 25.4391 16.7366 25.3368 16.815C24.8752 17.1692 24.6174 17.7348 24.1017 18.8661L23.3951 20.4163",
    stroke: "#DF0C3D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.083 33.25L25.083 26.25",
    stroke: "#DF0C3D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.917 33.25L30.917 26.25",
    stroke: "#DF0C3D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconNew);
export default __webpack_public_path__ + "static/media/delete-icon-new.030a89b66da96569a4c9444332f78d50.svg";
export { ForwardRef as ReactComponent };